<template>
    <div>
        přehled půjčených věcí
    </div>
</template>

<script>
    export default {
        name: "overview"
    }
</script>

<style scoped>

</style>